import {useRef, useSyncExternalStore, type ReactNode} from 'react';

import {useOnMount} from 'shared/web';

import type {BulkOperationActionCallbackParams} from '../../types/BulkOperationActionCallback';
import {CloseBulkOperationActionDialog} from './CloseBulkOperationActionDialog';

export function BulkOperationActionDialogContent(props: {
  action: BulkOperationActionCallbackParams;
  dialogId: string;
  onDismiss: () => void;
  children: ReactNode;
}) {
  const state = useSyncExternalStore(
    props.action.context.subscribe,
    props.action.context.getSnapshot
  );
  const mounted = useRef(false);
  useOnMount(
    () => {
      mounted.current = true;
    },
    () => {
      mounted.current = false;
      // Navigation removes dialogs without onCloseComplete. Allow StrictMode's
      // immediate effect reattachment before treating cleanup as dismissal.
      queueMicrotask(() => {
        if (!mounted.current) {
          props.onDismiss();
        }
      });
    }
  );
  return state.isClosed ? (
    <CloseBulkOperationActionDialog dialogId={props.dialogId} />
  ) : (
    props.children
  );
}
